// import React from "react";
// import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import { Provider } from "react-redux";
// import store from "./Store";


// import Login from "./components/Login";
// import PrivateRoute from "./components/PrivateRoute";
// import Status from "./components/Status";
// import ErrorPage from "./ResuableCompoment/ErrorPage";
// import PayUDasboard from "./components/PayUDashboard/PayUMain";
// import ForgotPassword from "./components/Forgotpassword";
// import DMT from "./components/RetailerDasboard/DMT/DMT";
// import AepsDashboard from "./components/RetailerDasboard/AePS/AepsDashboard";
// import RBDashboard from "./components/RetailerDasboard/RechargeandBills/RBDashboard";
// import RetailerDasboard from "./components/RetailerDasboard/RetailerDasboard";
// import DistributorDasboard from "./components/DistributorPortal/DistributorDasboard/DistributorDasboard";
// import MasterDistributorDasboard from "./components/MasterDistributorPortal/MasterDistributorDasboard/MasterDistributorDasboard";
// import RegisterCustomer from './components/RetailerDasboard/DMT/RegisterCustomer';
// import Remitter from "./components/RetailerDasboard/DMT/Remittence/Remitter";
// import AddBeneficiary from "./components/RetailerDasboard/DMT/Addbeneficiary/AddBeneficiary";
// import FundTransfer from "./components/RetailerDasboard/DMT/FundTransfer/FundTransfer";
// import Biometricdevices from "./ResuableCompoment/Biometricdevices";
// import TransferToDistributor from "./components/DistributorPortal/ManageWallet/TransfertoDistributor";
// import QRPayment from "./components/DistributorPortal/ManageWallet/QR";
// import MerchantTransfer from "./components/DistributorPortal/ManageWallet/MerchantTransfer";
// import CashDTracker from "./components/DistributorPortal/ManageWallet/CashTracker";
// import LedgerReport from "./components/RetailerDasboard/LedgerReport/LedegarReport";
// import PpiTransfer from "./components/RetailerDasboard/PPI/Ppitransfer";
// import RemitterPage from "./components/RetailerDasboard/PPI/RemitterPage";
// import PPIRemitter from "./components/RetailerDasboard/PPI/PPIRemitter";
// import AddNewBeneficiary from "./components/RetailerDasboard/PPI/AddNewBeneficiary";
// import AddAccount from "./components/RetailerDasboard/Payout/AddAccount";
// import PayoutReports from "./components/RetailerDasboard/Reports/PayoutReports";
// import DmtReports from "./components/RetailerDasboard/DMT/DmtReports";
// import PPITransaction from "./components/RetailerDasboard/PPI/PPITransaction";
// import MasterLedgerReport from "./components/MasterDistributorPortal/MasterReports/MasterLedgerReport";
// import DistributorLedgerReport from "./components/DistributorPortal/Reports/DistributorLedgerReport";
// import MasterCashTracker from "./components/MasterDistributorPortal/MasterManageWallet/MasterCashTracker";
// import MasterTransfertoDistributor from "./components/MasterDistributorPortal/MasterManageWallet/MasterTransfertoDistributor";
// import VerificationSuccess from "./ResuableCompoment/VerificationSuccess";
// import VerificationPending from "./ResuableCompoment/VerificationPending";
// import VerificationFailed from "./ResuableCompoment/VerificationFailed";
// import PGDashboard from "./components/RetailerDasboard/PaymentGateway/PGDashboard";
// import Ccbp from "./components/RetailerDasboard/Ccbp/Ccbp";
// import PaymentReports from "./components/RetailerDasboard/PaymentGateway/PaymentReports";
// import Rechargereports from "./components/RetailerDasboard/RechargeandBills/Rechargereports";
// import CcbpReports from "./components/RetailerDasboard/Ccbp/CcbpReports";
// import Profile from "./components/Profile";
// import Merchantekyc from "./components/RetailerDasboard/AePS/Merchantekyc";
// import AepsHistory from "./components/RetailerDasboard/AePS/AepsHistory";
// import BbpsOnline from "./components/RetailerDasboard/BBPSonline/BbpsOnline";
// import RechargePaymentScreen from "./components/RetailerDasboard/BBPSonline/RechargePaymentScreen";
// import RegisterCustomerinstpay from "./components/RetailerDasboard/DMT/RegisterCustomerinstpay";
// import Qrcodemerchant from "./components/RetailerDasboard/Qrcode/Qrcodemerchant";
// import TransactionHistory from "./ResuableCompoment/TransactionHistory";
// import Education from "./components/RetailerDasboard/Education/Education";
// import Fastag from "./components/RetailerDasboard/Fastag/Fastag";
// function App() {

//   const AppRouter = createBrowserRouter([
//     {
//       path: "/",
//       element: <Login />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/verificationsuccess",
//       element: <VerificationSuccess />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/verificationpending",
//       element: <VerificationPending />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/verificationfailed",
//       element: <VerificationFailed />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/forgotpassword",
//       element: <ForgotPassword />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/distributordashboard",
//       element: <PrivateRoute element={DistributorDasboard} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/profile",
//       element: <PrivateRoute element={Profile} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/dmttxnhistory",
//       element: <PrivateRoute element={DmtReports} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/qrcodemerchant",
//       element: <PrivateRoute element={Qrcodemerchant} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/transactionhistory",
//       element: <PrivateRoute element={TransactionHistory} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/pgtxnhistory",
//       element: <PrivateRoute element={PaymentReports} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/rechargetxnhistory",
//       element: <PrivateRoute element={Rechargereports} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/retailerledgerreport",
//       element: <PrivateRoute element={LedgerReport} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/masterdistributordashboard",
//       element: <PrivateRoute element={MasterDistributorDasboard} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/retailerdashboard",
//       element: <PrivateRoute element={RetailerDasboard} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/registercustomer",
//       element: <PrivateRoute element={RegisterCustomer} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/registercustomers",
//       element: <PrivateRoute element={RegisterCustomerinstpay} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/ppiservices",
//       element: <PrivateRoute element={PpiTransfer} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/education",
//       element: <PrivateRoute element={Education} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/fastagrecharge",
//       element: <PrivateRoute element={Fastag} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/payout",
//       element: <PrivateRoute element={AddAccount} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/mastercashtracker",
//       element: <PrivateRoute element={MasterCashTracker} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/mastertransfertodistributor",
//       element: <PrivateRoute element={MasterTransfertoDistributor} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/payoutReports",
//       element: <PrivateRoute element={PayoutReports} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/remittance",
//       element: <PrivateRoute element={Remitter} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/ppi-remitterpage",
//       element: <PrivateRoute element={RemitterPage} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/add-ppibeneficiary",
//       element: <PrivateRoute element={AddNewBeneficiary} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/ppi-transfer",
//       element: <PrivateRoute element={PPIRemitter} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/pg",
//       element: <PrivateRoute element={PGDashboard} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/ccbp",
//       element: <PrivateRoute element={Ccbp} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/dmtservices",
//       element: <PrivateRoute element={DMT} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/cashtracker",
//       element: <PrivateRoute element={CashDTracker} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/merchanttransferreversal",
//       element: <PrivateRoute element={MerchantTransfer} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/qrcode",
//       element: <PrivateRoute element={QRPayment} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/transfertodistributor",
//       element: <PrivateRoute element={TransferToDistributor} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/masterledgerreport",
//       element: <PrivateRoute element={MasterLedgerReport} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/distributorledgerreport",
//       element: <PrivateRoute element={DistributorLedgerReport} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/addbeneficiary",
//       element: <PrivateRoute element={AddBeneficiary} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/fundtransfer",
//       element: <PrivateRoute element={FundTransfer} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/aepsservices",
//       element: <PrivateRoute element={AepsDashboard} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/aepshistory",
//       element: <PrivateRoute element={AepsHistory} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/merchantekyc",
//       element: <PrivateRoute element={Merchantekyc} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/rbservices",
//       element: <PrivateRoute element={RBDashboard} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/bbpsonline",
//       element: <PrivateRoute element={BbpsOnline} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/bbpsonline/recharge-payment",
//       element: <PrivateRoute element={RechargePaymentScreen} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },

//     {
//       path: "/health",
//       element: <Status />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/biometricdevices",
//       element: <Biometricdevices />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/ppitransactions",
//       element: <PrivateRoute element={PPITransaction} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/ccbptxnhistory",
//       element: <PrivateRoute element={CcbpReports} withLayout={true} />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/payu",
//       element: <PayUDasboard />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/health/liveness",
//       element: <Status />,
//       errorElement: <ErrorPage />,
//     },
//     {
//       path: "/health/readiness",
//       element: <Status />,
//       errorElement: <ErrorPage />,
//     },
//   ]);

//   return (
//     <Provider store={store}>
//       <div>
//         <RouterProvider router={AppRouter} />
//       </div>
//     </Provider>
//   );
// }

// export default App;











import React from "react";
import { createBrowserRouter, RouterProvider  } from "react-router-dom";
// import { createBrowserRouter, RouterProvider , Outlet } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Store";
import SessionGuard from "./SessionGuard";

import PrivateRoute from "./components/PrivateRoute";
import MiniLayout from "./ResuableCompoment/MiniLayout";

/* AUTH / COMMON */
import Login from "./components/Login";
import MpinVerify from "./components/MpinVerify";
import MpinUnlockModal from "./components/MpinUnlockModal";
import ErrorPage from "./ResuableCompoment/ErrorPage";
import Status from "./components/Status";
import ForgotPassword from "./components/Forgotpassword";

/* DASHBOARDS */
import RetailerDasboard from "./components/RetailerDasboard/RetailerDasboard";
import DistributorDasboard from "./components/DistributorPortal/DistributorDasboard/DistributorDasboard";
import MasterDistributorDasboard from "./components/MasterDistributorPortal/MasterDistributorDasboard/MasterDistributorDasboard";

/* SERVICES */
import DMT from "./components/RetailerDasboard/DMT/DMT";
// import AepsDashboard from "./components/RetailerDasboard/AePS/AepsDashboard";
import AepsDashboard from "./components/RetailerDasboard/NewAeps/AepsDashboard";
import RBDashboard from "./components/RetailerDasboard/BBPSonline/BbpsOnline1";
import PpiTransfer from "./components/RetailerDasboard/PPI/Ppitransfer";
import PGDashboard from "./components/RetailerDasboard/PaymentGateway/PGDashboard";
import Ccbp from "./components/RetailerDasboard/Ccbp/CCBPDashboard";
import Education from "./components/RetailerDasboard/Education/Education";
import Fastag from "./components/RetailerDasboard/Fastag/Fastag";

/* REPORTS & OTHERS */
import LedgerReport from "./components/RetailerDasboard/LedgerReport/LedegarReport";
import TransactionHistory from "./ResuableCompoment/TransactionHistory";
import Profile from "./components/Profile";
import Merchantekyc from "./components/RetailerDasboard/AePS/Merchantekyc";
import DmtReports from "./components/RetailerDasboard/DMT/DmtReports";
import AepsHistory from "./components/RetailerDasboard/AePS/AepsHistory";

import AddBeneficiarySoliteck from "./components/RetailerDasboard/AePS/AddBeneficiarySoliteck";
// import AepsSettlementSoliteck from "./components/RetailerDasboard/AePS/AepsSettlementSolitech";
import AepsSettlementSolitecklogin from "./components/RetailerDasboard/AePS/Aepssettlementsolitecklogin";
import PayoutReports from "./components/RetailerDasboard/Reports/PayoutReports";
import Rechargereports from "./components/RetailerDasboard/RechargeandBills/Rechargereports";
import CcbpReports from "./components/RetailerDasboard/Ccbp/CcbpReports";
import PPITransaction from "./components/RetailerDasboard/PPI/PPITransaction";
import PaymentReports from "./components/RetailerDasboard/PaymentGateway/PaymentReports";
import RegisterCustomerinstpay from "./components/RetailerDasboard/DMT/RegisterCustomerinstpay";
import Remitter from "./components/RetailerDasboard/DMT/Remittence/Remitter";
import AddBeneficiary from "./components/RetailerDasboard/DMT/Addbeneficiary/AddBeneficiary";
import FundTransfer from "./components/RetailerDasboard/DMT/FundTransfer/FundTransfer";
import MasterTransfetToDistributor from "./components/MasterDistributorPortal/MasterManageWallet/MasterTransfertoDistributor";
import { QrCode } from "lucide-react";
import QRPayment from "./components/DistributorPortal/ManageWallet/QR";
import MerchantTransfer from "./components/DistributorPortal/ManageWallet/MerchantTransfer";
import CashDTracker from "./components/DistributorPortal/ManageWallet/CashTracker";
import DistributorLedgerReport from "./components/DistributorPortal/Reports/DistributorLedgerReport";
import MasterCashTracker from "./components/MasterDistributorPortal/MasterManageWallet/MasterCashTracker";
import MasterLedgerReport from "./components/MasterDistributorPortal/MasterReports/MasterLedgerReport";
import MobileRecharge from "./components/RetailerDasboard/ReachargeNew/MobileRecharge";
import MobileRecharge3 from "./components/RetailerDasboard/ReachargeNew/MobileRecharge3";
import Banks from "./ResuableCompoment/Banks";
import ContactUs from "./ResuableCompoment/ContactUs";
import RetailerCashInReport from "./components/DistributorPortal/Reports/RetailerCashInReport";
// import ElectricityBillPay from "./components/RetailerDasboard/RechargeandBills/ElectricityBillPay";
import BillOffline from "./components/RetailerDasboard/RechargeandBills/BillOffline";
import BillPaymentReports from "./components/RetailerDasboard/RechargeandBills/BillPaymentReports";
import CashInRequest from "./components/RetailerDasboard/CashInRequest";
import AepsSettlement1 from "./components/RetailerDasboard/AePS/AepsSettlement1";
import AepsRemitter from "./components/RetailerDasboard/AePS/AepsRemitter";
import AepsAddBeneficiary from "./components/RetailerDasboard/AePS/AepsAddBeneficiary";
import AepsFundTransfer from "./components/RetailerDasboard/AePS/AepsFundTransfer";
// import OperatorSelection from "./components/RetailerDasboard/ReachargeNew/OperatorSelection";
import MobileRecharge1 from "./components/RetailerDasboard/ReachargeNew/MobileRecharge1";
import AepsSettlement2 from "./components/RetailerDasboard/AePS/AepsSettlement2";
import AepsRemitter2 from "./components/RetailerDasboard/AePS/AepsRemitter2";
import AepsFundTransfer2 from "./components/RetailerDasboard/AePS/AepsFundTransfer2";
import NewPPIMain from "./components/RetailerDasboard/NewPPI/NewPPIMain";
import PPIHistory from "./components/RetailerDasboard/NewPPI/PPIHistory";
import Ppisettlement1 from "./components/RetailerDasboard/PPI/Ppisettlement1";
import PpiFundTransfer from "./components/RetailerDasboard/PPI/PpiFundTransfer";
import PpiRemitter from "./components/RetailerDasboard/PPI/Remitter";
import Settlement2Remitter from "./components/RetailerDasboard/AePS/Settlement2Remitter";
import AddBeneficiaryIMPS2 from "./components/RetailerDasboard/AePS/AddBeneficiaryIMPS2";
import Settlement1FundTransfer from "./components/RetailerDasboard/AePS/Settlement1FundTransfer";
import SettlementSoliteckfundtransfer from "./components/RetailerDasboard/AePS/SettlementSoliteckfundtransfer";
import AddNewBeneficiary from "./components/RetailerDasboard/PPI/AddNewBeneficiary";
import BanksDistributor from "./ResuableCompoment/BanksDistributor";
import MerchantOnboard from "./components/DistributorPortal/MerchantOnboard/MerchantOnboard";
import DistributorReports from "./components/DistributorPortal/Reports/DistributorReports";
import DistributorReports1 from "./components/DistributorPortal/Reports/DistributorReports1";
import MasterLedgerReport1 from "./components/MasterDistributorPortal/MasterReports/MasterLedgerReport1";
import CommissionReport from "./components/DistributorPortal/Reports/CommissionReport";
import CommissionRetailer from "./components/RetailerDasboard/LedgerReport/CommissionRetailer";
import AepsReport from "./components/RetailerDasboard/LedgerReport/AepsReport";
import MasterCommissionReport from "./components/MasterDistributorPortal/MasterReports/MasterCommissionReport";
import RetailerBalance from "./components/DistributorPortal/RetailerBalance/RetailerBalance";
import DthRecharge from "./components/RetailerDasboard/DTH/DthRecharge";
import WallettoWallet from "./components/DistributorPortal/WallettoWallet/WallettoWallet";
import CMS from "./components/RetailerDasboard/CMS1/CMS2";
import UpiCashoutGateway from "./components/RetailerDasboard/UpiCashout/UpiCashoutGateway";
import BingoCertificate from "./components/Certificate/BingoCertificate";
import AepsSettlement3 from "./components/RetailerDasboard/AePS/AepsSettlement3";
import AepsRemitter3 from "./components/RetailerDasboard/AePS/AepsRemitter3";
import MobileRecharge2 from "./components/RetailerDasboard/ReachargeNew/MobileRecharge2";
import VerificationPending from "./ResuableCompoment/VerificationPending";
import VerificationSuccess from "./ResuableCompoment/VerificationSuccess";
import VerificationFailed from "./ResuableCompoment/VerificationFailed";
// import UnderMaintenance from "./ResuableCompoment/UnderMaintenance";
import CashInRequest1 from "./components/RetailerDasboard/CashInRequest1";
import CashInRequestTable from "./components/RetailerDasboard/CashInRequestTable";
import MerchantTransferTable from "./components/DistributorPortal/ManageWallet/MerchantTransferTable";
import AepsIntegration from "./components/RetailerDasboard/NewAeps/AepsIntegration";
import AepsIntegration1 from "./components/RetailerDasboard/NewAeps/AepsIntegration1";
import SubhearnAepsIntegration from "./components/RetailerDasboard/NewAeps/SubhearnAepsIntegration";
import SubhearnBank5AepsIntegration from "./components/RetailerDasboard/NewAeps/SubhearnBank5AepsIntegration";
import VimoAepsIntegration from "./components/RetailerDasboard/VimoAEPS/VimoAepsIntegration";
import VimoAepsIntegration1 from "./components/RetailerDasboard/VimoAEPS1/VimoAepsIntegration1";
import Qrcodemerchant from "./components/RetailerDasboard/Qrcode/Qrcodemerchant";
import Subscription from "./ResuableCompoment/Subscription";
import RateList from "./components/RetailerDasboard/Ratelist";
import UploadInvoice from "./components/UploadInvoice/UploadInvoice";
import Verification from "./components/RetailerDasboard/Verification";
import BbpsOnlineHistory1 from "./components/RetailerDasboard/BBPSonline/BbpsOnlineHistory1";
import IndoNepal from "./components/RetailerDasboard/IndoNepal/Indonepal";
import AadhaarPayDashboard from "./components/RetailerDasboard/AadhaarPay/AadhaarPayDashboard";
import AadhaarPayIntegration from "./components/RetailerDasboard/AadhaarPay/AadhaarPayIntegration";
import VimoApIntegration2 from "./components/RetailerDasboard/AadhaarPay/AadhaarPay2/VimoApIntegration2";
import VimoApIntegration3 from "./components/RetailerDasboard/AadhaarPay/AadhaarPay3/VimoApIntegration3";
import OdDashboard from "./components/RetailerDasboard/OD/OdDashboard";
import SettlementRemitterSoliteck from "./components/RetailerDasboard/AePS/SettlementRemmiterSoliteck";
import ElectricityBillPay from "./components/RetailerDasboard/RechargeandBills/ElectricityBillPay";
import GasBillpay from "./components/RetailerDasboard/RechargeandBills/GasBillpay";
import InsuranceBillPay from "./components/RetailerDasboard/RechargeandBills/InsuranceBillPay";
import FlightSearch from "./components/RetailerDasboard/Air/FlightSearch";
import FlightSSRSeat from "./components/RetailerDasboard/Air/FlightSSRSeat";
import FlightBooking from "./components/RetailerDasboard/Air/FlightBooking";
import FlightConfirm from "./components/RetailerDasboard/Air/FlightConfirm";
import FlightHistory from "./components/RetailerDasboard/Air/FlightHistory";
import FinkedaHistory from "./components/RetailerDasboard/PaymentGateway/FinkedaHistory";
// import DmtDashboard from "./components/RetailerDasboard/DMT/DmtDashboard";
// import SubhearnDmt from "./components/RetailerDasboard/DMT/SubhearnDmt/SubhearnDmt";
import AxisCard from "./components/RetailerDasboard/AxisCard/AxisCard";
// import { useDevToolsDetector } from "./CustomHooks/useDevToolsDetector";
function App() {
  
//   const RootLayout = () => {
//   useDevToolsDetector();
//   return <Outlet />;
// };

  const AppRouter = createBrowserRouter([
  //  { 
  //   element: <RootLayout />,
  //   children: [
    /* ---------- PUBLIC ROUTES ---------- */
    { path: "/", element: <Login /> },
    // { path: "/", element: <UnderMaintenance /> },
    { path: "/forgotpassword", element: <ForgotPassword /> },
    { path: "/mpin-verify", element: <MpinVerify /> },

    /* ---------- PROTECTED ROUTES ---------- */
    {
      path: "/",
      element: (
        // <PrivateRoute>
        //   <MiniLayout />
        // </PrivateRoute>
        <SessionGuard>
          <PrivateRoute>
            <MiniLayout />
          </PrivateRoute>
        </SessionGuard>
      ),
      children: [
        { path: "retailerdashboard", element: <RetailerDasboard /> },
        { path: "distributordashboard", element: <DistributorDasboard /> },
        { path: "masterdistributordashboard", element: <MasterDistributorDasboard /> },
        { path: "qrmerchant", element: <Qrcodemerchant /> },

        // { path: "dmtdashboard", element: <DmtDashboard /> },
        { path: "dmtservices", element: <DMT /> },
        // { path: "subhearndmt", element: <SubhearnDmt /> },
        { path: "cdmcard", element: <AxisCard /> },
        // { path: "selectedopt", element: <OperatorSelection /> },
        { path: "selectedopt", element: <MobileRecharge2 /> },
        { path: "mobilerecharge", element: <MobileRecharge3 /> },
        { path: "mobilerecharge1", element: <MobileRecharge1 /> },
        { path: "aeps", element: <AepsDashboard /> },
        { path: "aepsform", element: <AepsIntegration /> },
        { path: "aepsform1", element: <AepsIntegration1 /> },
        { path: "aepsform2", element: <SubhearnAepsIntegration /> },
        { path: "aepsform3", element: <SubhearnBank5AepsIntegration /> },
        { path: "aepsform4", element: <VimoAepsIntegration /> },
        { path: "aepsform5", element: <VimoAepsIntegration1 /> },
        { path: "rbservices", element: <RBDashboard /> },
        // { path: "electricity-bill", element: <ElectricityBillPay /> },
        { path: "billoffline", element: <BillOffline /> },
        { path: "ppiservices", element: <PpiTransfer /> },
        { path: "pg", element: <PGDashboard /> },
        { path: "ccbp", element: <Ccbp /> },
        { path: "education", element: <Education /> },
        { path: "fastagrecharge", element: <Fastag /> },
        { path: "dmttxnhistory", element: <DmtReports /> },
        { path: "aepshistory", element: <AepsHistory /> },
        { path: "bbpsonlinehistory", element: <BbpsOnlineHistory1 /> },
        { path: "payoutReports", element: <PayoutReports /> },
        { path: "rechargetxnhistory", element: <Rechargereports /> },
        { path: "billpayhistory", element: <BillPaymentReports /> },
        { path: "ccbptxnhistory", element: <CcbpReports /> },
        { path: "ppitransactions", element: <PPITransaction /> },
        { path: "pgtxnhistory", element: <PaymentReports /> },
        { path: "pgtxnbankhistory", element: <FinkedaHistory /> },
        { path: "remittance", element: <Remitter /> },
        { path: "addbeneficiary", element: <AddBeneficiary /> },
        { path: "fundtransfer", element: <FundTransfer /> },
        { path: "cashinrequest", element: <CashInRequest1 /> },
        { path: "cashinrequesttable", element: <CashInRequestTable /> },
        { path: "aepssettlement1", element: <AepsSettlement1 /> },
        { path: "aepssettlement2", element: <AepsSettlement2 /> },
        { path: "aepssettlement3", element: <AepsSettlement3 /> },
        { path: "aepsremitter2", element: <AepsRemitter2 /> },
        { path: "aepsremitter3", element: <AepsRemitter3 /> },
        { path: "aepsfundtransfer2", element: <AepsFundTransfer2 /> },
        { path: "aepsremitter", element: <AepsRemitter /> },
        { path: "aepsaddbeneficiary", element: <AepsAddBeneficiary /> },
        { path: "aepsfundtransfer", element: <AepsFundTransfer /> },
        { path: "ppimain", element: <NewPPIMain /> },
        { path: "ppihistory", element: <PPIHistory /> },
        { path: "ppi", element: <Ppisettlement1 /> },
        { path: "ppiremitter", element: <PpiRemitter /> },
        { path: "ppifundtransfer", element: <PpiFundTransfer /> },
        { path: "settlement2remitter", element: <Settlement2Remitter /> },
        { path: "add-beneficiary-imps2", element: <AddBeneficiaryIMPS2 /> },
        { path: "settlement1fundtransfer", element: <Settlement1FundTransfer /> },
        { path: "settlementimps2fundtransfer", element: <SettlementSoliteckfundtransfer /> },
        { path: "ppiaddbeneficiary", element: <AddNewBeneficiary /> },
        { path: "dth", element: <DthRecharge /> },
        { path: "cms", element: <CMS /> },
        { path: "upicashout", element: <UpiCashoutGateway /> },
        { path: "certificate", element: <BingoCertificate /> },
        { path: "fastag", element: <Fastag /> },

        { path: "flight-search", element: <FlightSearch /> },
        { path: "flight-ssr-seat", element: <FlightSSRSeat /> },
        { path: "flight-booking", element: <FlightBooking /> },
        { path: "flight-confirm", element: <FlightConfirm /> },
        { path: "flight-history", element: <FlightHistory /> },

        { path: "banks", element: <Banks /> },
        { path: "banksdistributor", element: <BanksDistributor /> },
        { path: "merchantonboard", element: <MerchantOnboard /> },
        { path: "contact-us", element: <ContactUs /> },

        { path: "transactionhistory", element: <TransactionHistory /> },
        { path: "merchantekyc", element: <Merchantekyc /> },
        { path: "retailerledgerreport", element: <LedgerReport /> },
        { path: "registercustomers", element: <RegisterCustomerinstpay /> },
        { path: "profile", element: <Profile /> },

        { path: "qrcode", element: <QRPayment /> },
        { path: "merchanttransferreversal", element: <MerchantTransfer /> },
        { path: "merchanttransferreversalreport", element: <MerchantTransferTable /> },
        { path: "cashtracker", element: <CashDTracker /> },
        { path: "distributorledgerreport", element: <DistributorLedgerReport /> },
        { path: "ledgerreport", element: <DistributorReports /> },
        { path: "distributorreports", element: <DistributorReports1 /> },
        { path: "retailercashinreport", element: <RetailerCashInReport /> },
        { path: "retailerbalance", element: <RetailerBalance /> },
        { path: "wallettowallet", element: <WallettoWallet /> },

        { path: "mastercashtracker", element: <MasterCashTracker /> },
        { path: "mastertransfertodistributor", element: <MasterTransfetToDistributor /> },
        { path: "masterledgerreport", element: <MasterLedgerReport /> },
        { path: "masterledgerreport1", element: <MasterLedgerReport1 /> },
        { path: "commissionledgermd", element: <MasterCommissionReport /> },
        { path: "commissionledger", element: <CommissionReport /> },
        { path: "commissionretailer", element: <CommissionRetailer /> },
        { path: "aepsledger", element: <AepsReport /> },


        { path: "electricitybillpay", element: <ElectricityBillPay /> },
        { path: "gasbillpay", element: <GasBillpay /> },
        { path: "insurance", element: <InsuranceBillPay /> },

        { path: "ratelist", element: <RateList /> },
        { path: "uploadinvoice", element: <UploadInvoice /> },

        { path: "health", element: <Status /> },
        { path: "verificationpending", element: <VerificationPending /> },
        { path: "verificationsuccess", element: <VerificationSuccess /> },
        { path: "verificationfailed", element: <VerificationFailed /> },
        { path: "subscription", element: <Subscription /> },
        { path: "verification", element: <Verification /> },
        { path: "indonepal", element: <IndoNepal /> },
        { path: "aadhaarpaydashboard", element: <AadhaarPayDashboard /> },
        { path: "aadhaar-pay", element: <AadhaarPayIntegration /> },
        { path: "aadhaar-pay-2", element: <VimoApIntegration2 /> },
        { path: "aadhaar-pay-3", element: <VimoApIntegration3 /> },
        { path: "oddashboard", element: <OdDashboard /> },
        // soliteck
        { path: "addbeneimps2", element: <AddBeneficiarySoliteck /> },
        { path: "aepssettlement1imps2", element: <AepsSettlementSolitecklogin /> },
        { path: "settlementremitter2", element: <SettlementRemitterSoliteck /> }


      ],
    },

    /* ---------- FALLBACK ---------- */
    { path: "*", element: <ErrorPage /> },
  // ]}
  ]);

  // return (
  //   <Provider store={store}>
  //     <RouterProvider router={AppRouter} />
  //   </Provider>
  // );
  return (
    // <Provider store={store}>
    //   <SessionGuard>
    //     <RouterProvider router={AppRouter} />
    //   </SessionGuard>
    // </Provider>
    <Provider store={store}>
      <RouterProvider router={AppRouter} />
      <MpinUnlockModal />
    </Provider>
  );
}

export default App;
